import {importFile, MainRequest} from '../../../Services/common';
import {download} from '../../../Utils/common';
import {Key} from 'react';

export interface FunctionListTree {
    id: string;
    name: string;
    code: string;
    levelType: string;
    selectStatus: BooleanValue;
    defaultFlag: BooleanValue;
    children?: FunctionListTree[];
}

export function getRoleFunctionTree(roleId: string) {
    return MainRequest.post<SuccessData<FunctionListTree[]>>(
        '/role/getFuncTree',
        {roleId},
    ).then(res => res.data.data);
}

/**
 * 保存角色权限
 * @param roleId
 * @param funId
 */
export function saveRoleFunction(roleId: string, funId: string[]) {
    return MainRequest.post('/function/saveRoleFunction', {
        roleId,
        funId: funId.join(','),
    });
}

/**
 * 删除角色权限
 * @param roleId
 * @param funId
 */
export function deleteRoleFunction(roleId: string, funId: string[]) {
    return MainRequest.post('/function/deleteRoleFunction', {
        roleId,
        funId: funId.join(','),
    });
}

export interface RoleForm {
    id?: string; // 传参更新， 不传新增
    roleName: string; // 角色名称
    code: string; // 角色编号
    status: string; //  1启用 0停用
}

/**
 * 角色保存
 * @param data
 */
export function saveRole(data: RoleForm) {
    return MainRequest.post('/role/save', data);
}

/**
 * 角色修改启用停用状态
 * @param id
 * @param status
 */
export function changeStatus(id: string, status: string) {
    return MainRequest.post('/role/changeStatus', {id, status});
}

/**
 * 角色删除
 * @param id
 */
export function deleteRole(id: string) {
    return MainRequest.post('/role/delete', {id});
}

export interface RoleUserItem {
    id: string;
    defaultFlag: string;
    defaultRole: string;
    roleCode: string;
    roleId: string;
    roleName: string;
    userId: string;
    userName: string;
    userCode: string;
    userStatus: string; // 1正常 0冻结
}

/**
 * 角色人员授权列表
 * @param roleId
 */
export function getRoleUserList(roleId: string) {
    return MainRequest.post<SuccessData<RoleUserItem[]>>(
        '/role/getRoleUserList',
        {roleId},
    ).then(res => res.data.data);
}

/**
 * 导入授权人员
 * @param file
 */
export function importRoleUserExcel(file: File) {
    return importFile('/role/importRoleUserExcel', file);
}

/**
 * 导出授权人员
 */
export function exportRoleUserExcel() {
    return download('/role/exportRoleUserExcel', {method: 'post'});
}

/**
 * 角色人员取消授权
 * @param userId
 * @param roleId
 */
export function deleteUserRole(userId: Key[], roleId: string) {
    return MainRequest.post('/role/deleteUserRole', {
        userId: userId.join(','),
        roleId,
    });
}

/**
 * 角色分配人员
 * @param userId
 * @param roleId
 */
export function saveUserRole(userId: string, roleId: string) {
    return MainRequest.post('/role/saveUserRole', {userId, roleId});
}
